import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../../Axios';

const AddProject = () => {
  const [projectName, setProjectName] = useState('');
  const [studentName, setStudentName] = useState('');
  const [projectDescription, setProjectDescription] = useState('');
  const [technologiesUsed, setTechnologiesUsed] = useState('');
  const [submittedDate, setSubmittedDate] = useState('');
  const [projectImage, setProjectImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append('projectName', projectName);
    formData.append('studentName', studentName);
    formData.append('projectDescription', projectDescription);
    formData.append('technologiesUsed', technologiesUsed);
    formData.append('submittedDate', submittedDate);
    if (projectImage) {
      formData.append('projectImage', projectImage);
    }
    try {
      await api.post('/api/v1/projects/create', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success('Project added successfully!');
      setProjectName('');
      setStudentName('');
      setProjectDescription('');
      setTechnologiesUsed('');
      setSubmittedDate('');
      setProjectImage(null);
    } catch (error) {
      toast.error(error.response?.data?.message || 'An error occurred while adding the project.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-6 space-y-8">
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="bg-[#00BFA5] text-black text-center font-bold py-4 px-6 max-w-4xl mx-auto text-xl sm:text-2xl md:text-3xl rounded-lg shadow-lg">
        Add Project
      </div>
      <form onSubmit={handleSubmit} className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-lg space-y-4">
        <div className="space-y-1">
          <label className="text-sm font-semibold">Project Name</label>
          <input
            type="text"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            required
          />
        </div>
        <div className="space-y-1">
          <label className="text-sm font-semibold">Student Name</label>
          <input
            type="text"
            value={studentName}
            onChange={(e) => setStudentName(e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            required
          />
        </div>
        <div className="space-y-1">
          <label className="text-sm font-semibold">Project Description</label>
          <textarea
            value={projectDescription}
            onChange={(e) => setProjectDescription(e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            required
          />
        </div>
        <div className="space-y-1">
          <label className="text-sm font-semibold">Technologies Used</label>
          <input
            type="text"
            value={technologiesUsed}
            onChange={(e) => setTechnologiesUsed(e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            required
          />
        </div>
        <div className="space-y-1">
          <label className="text-sm font-semibold">Submitted Date</label>
          <input
            type="date"
            value={submittedDate}
            onChange={(e) => setSubmittedDate(e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            required
          />
        </div>
        <div className="space-y-1">
          <label className="text-sm font-semibold">Project Image</label>
          <input
            type="file"
            onChange={(e) => setProjectImage(e.target.files[0])}
            className="w-full border border-gray-300 rounded-md p-2"
          />
        </div>
        <div className="flex justify-end">
          <button
            type="submit"
            className="bg-teal-500 text-white px-4 py-2 rounded-md"
            disabled={loading}
          >
            {loading ? 'Adding...' : 'Add Project'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddProject;